import WithoutFtdFilter from "./WithoutFtdFilter"
import WithoutFtdItem from "./WithoutFtdItem"

const WithoutFtd = () => {
  return (
    <>
    <WithoutFtdFilter/>
    <WithoutFtdItem/>
    </>
  )
}

export default WithoutFtd